import { render, staticRenderFns } from "./FormProductSupplier.vue?vue&type=template&id=dd601892&"
import script from "./FormProductSupplier.vue?vue&type=script&lang=ts&"
export * from "./FormProductSupplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd601892')) {
      api.createRecord('dd601892', component.options)
    } else {
      api.reload('dd601892', component.options)
    }
    module.hot.accept("./FormProductSupplier.vue?vue&type=template&id=dd601892&", function () {
      api.rerender('dd601892', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Product/FormProductSupplier.vue"
export default component.exports